import { create } from 'zustand';
import { supabase } from '@/integrations/supabase/client';
import { WebinarStore, Webinar } from './types';

export const useWebinarStore = create<WebinarStore>((set, get) => ({
  webinars: [],
  currentWebinar: null,
  loading: false,
  error: null,

  fetchWebinars: async () => {
    set({ loading: true, error: null });
    try {
      // TODO: Uncomment after running database migrations
      // const { data, error } = await supabase
      //   .from('webinars')
      //   .select('*')
      //   .order('created_at', { ascending: false });
      // if (error) throw error;
      // set({ webinars: data || [], loading: false });
      
      // Temporary: Return empty array until DB is set up
      set({ webinars: [], loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
    }
  },

  fetchWebinarById: async (id: string) => {
    set({ loading: true, error: null });
    try {
      // TODO: Uncomment after running database migrations
      // const { data, error } = await supabase
      //   .from('webinars')
      //   .select('*')
      //   .eq('id', id)
      //   .single();
      // if (error) throw error;
      // set({ currentWebinar: data, loading: false });
      
      // Temporary: Return null until DB is set up
      set({ currentWebinar: null, loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
    }
  },

  createWebinar: async (data: Partial<Webinar>) => {
    set({ loading: true, error: null });
    try {
      // TODO: Uncomment after running database migrations
      // const { data: newWebinar, error } = await supabase
      //   .from('webinars')
      //   .insert([{
      //     user_id: data.user_id,
      //     name: data.name || 'Novo Webinário',
      //     title: data.title || '',
      //     slug: data.slug || `webinar-${Date.now()}`,
      //     language: data.language || 'pt-BR',
      //     easy_access: data.easy_access || false,
      //     sync_with_time: data.sync_with_time || false,
      //     type: data.type || 'single',
      //     schedule_json: data.schedule_json,
      //     status: 'draft'
      //   }])
      //   .select()
      //   .single();
      // if (error) throw error;
      // set(state => ({
      //   webinars: [newWebinar, ...state.webinars],
      //   currentWebinar: newWebinar,
      //   loading: false
      // }));
      // return newWebinar.id;
      
      // Temporary: Return mock ID until DB is set up
      const mockId = `temp-${Date.now()}`;
      set({ loading: false });
      return mockId;
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  updateWebinar: async (id: string, data: Partial<Webinar>) => {
    set({ loading: true, error: null });
    try {
      // TODO: Uncomment after running database migrations
      // const { error } = await supabase
      //   .from('webinars')
      //   .update(data)
      //   .eq('id', id);
      // if (error) throw error;
      // set(state => ({
      //   webinars: state.webinars.map(w => w.id === id ? { ...w, ...data } : w),
      //   currentWebinar: state.currentWebinar?.id === id 
      //     ? { ...state.currentWebinar, ...data } 
      //     : state.currentWebinar,
      //   loading: false
      // }));
      
      // Temporary: Do nothing until DB is set up
      set({ loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  deleteWebinar: async (id: string) => {
    set({ loading: true, error: null });
    try {
      // TODO: Uncomment after running database migrations
      // const { error } = await supabase
      //   .from('webinars')
      //   .delete()
      //   .eq('id', id);
      // if (error) throw error;
      // set(state => ({
      //   webinars: state.webinars.filter(w => w.id !== id),
      //   currentWebinar: state.currentWebinar?.id === id ? null : state.currentWebinar,
      //   loading: false
      // }));
      
      // Temporary: Do nothing until DB is set up
      set({ loading: false });
    } catch (error: any) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  setCurrentWebinar: (webinar: Webinar | null) => {
    set({ currentWebinar: webinar });
  }
}));
